(() => {
  function closeMenu(dialog) {
    if (dialog.open) dialog.close();
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-fp-menu-toggle]');
    if (toggle) {
      const dialog = toggle.closest('[data-fp-header]').querySelector('dialog');
      dialog.showModal();
      dialog.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('fp-header-menu-open');
      return;
    }
    const dialog = event.target.closest('dialog.fp-header__drawer');
    if (!dialog) return;
    if (event.target.closest('[data-fp-menu-close], a')) closeMenu(dialog);
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeMenu(dialog);
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('dialog.fp-header__drawer')) return;
    event.target.classList.remove('is-open');
    document.documentElement.classList.remove('fp-header-menu-open');
    const toggle = event.target.closest('[data-fp-header]').querySelector('[data-fp-menu-toggle]');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus({preventScroll: true});
  }, true);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-fp-company-open]');
    const dialog = opener ? opener.closest('#site-footer').querySelector('dialog.fp-footer__company') : event.target.closest('dialog.fp-footer__company');
    if (!dialog) return;
    if (opener) dialog.showModal();
    else if (event.target === dialog || event.target.closest('[data-fp-company-close]')) dialog.close();
  });
  window.matchMedia('(min-width: 997px)').addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('dialog.fp-header__drawer[open]').forEach(closeMenu);
  });
})();
